import { render, staticRenderFns } from "./mobile_container_demand_detail.vue?vue&type=template&id=18b11cee&scoped=true&"
import script from "./mobile_container_demand_detail.vue?vue&type=script&lang=js&"
export * from "./mobile_container_demand_detail.vue?vue&type=script&lang=js&"
import style0 from "./mobile_container_demand_detail.vue?vue&type=style&index=0&id=18b11cee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b11cee",
  null
  
)

export default component.exports